export const basename = process.env.REACT_APP_PAGE_ROOT || "/";
